import React from "react";
import { Star, ArrowRight } from "lucide-react";
import SEO from "../components/SEO";
import { businessInfo, testimonials } from "../data/content";
import { getBreadcrumbJsonLd } from "../data/jsonld";

export default function Reviews() {
  return (
    <>
      <SEO
        title="Avis Clients - Plombier à Meaux (77) | Pereira Plomberie Chauffage"
        description="Découvrez les avis de nos clients. Note moyenne 4,8/5 sur Google avec plus de 140 avis. Artisan plombier chauffagiste de confiance à Meaux."
        jsonLd={getBreadcrumbJsonLd([
          { name: "Accueil", url: "/" },
          { name: "Avis clients" },
        ])}
      />

      {/* Header */}
      <section className="bg-primary text-white py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-sm font-accent font-medium tracking-widest text-secondary uppercase mb-2">Confiance</p>
          <h1 className="font-heading text-4xl md:text-6xl font-bold uppercase tracking-tight" data-testid="reviews-title">
            Avis clients
          </h1>
          <div className="flex items-center gap-3 mt-6">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={24} className="text-yellow-500 fill-yellow-500" />
              ))}
            </div>
            <span className="text-2xl font-bold">{businessInfo.googleReviewRating}/5</span>
            <span className="text-slate-400">({businessInfo.googleReviewCount}+ avis Google)</span>
          </div>
        </div>
      </section>

      {/* Reviews */}
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto">
            <p className="text-lg text-slate-600 leading-relaxed mb-10">
              La satisfaction de nos clients est notre meilleure récompense. Voici quelques témoignages récents de personnes que nous avons accompagnées à Meaux et dans les communes voisines.
            </p>

            <div className="space-y-6">
              {testimonials.map((t, i) => (
                <div key={i} className="bg-white p-8 border-l-4 border-secondary shadow-sm rounded-r-md" data-testid={`review-${i}`}>
                  <div className="flex items-center gap-3 mb-4">
                    <div className="flex">
                      {[...Array(t.rating)].map((_, j) => (
                        <Star key={j} size={16} className="text-yellow-500 fill-yellow-500" />
                      ))}
                    </div>
                    <span className="font-heading font-semibold text-sm uppercase tracking-wide">{t.author}</span>
                  </div>
                  <p className="text-slate-700 italic text-lg leading-relaxed">"{t.text}"</p>
                </div>
              ))}
            </div>

            <div className="text-center mt-12 p-8 bg-muted rounded-sm border border-slate-200">
              <h2 className="font-heading text-2xl font-bold uppercase tracking-tight mb-3">Voir tous nos avis</h2>
              <p className="text-slate-600 mb-6">
                Retrouvez l'ensemble de nos avis vérifiés sur notre fiche Google Business.
              </p>
              <a
                href={businessInfo.googleReviewUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-secondary hover:bg-secondary/90 text-white font-bold uppercase tracking-wider py-3 px-8 rounded-sm text-sm transition-all"
                data-testid="google-reviews-button"
              >
                Voir sur Google <ArrowRight size={16} />
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
